<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="机构账号编码" prop="accountCode">
            <el-input
              v-model="formData.accountCode"
              clearable
              placeholder="请输入机构账号编码"
              maxlength="36"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="开发者账号" prop="appId">
            <el-input
              v-model="formData.appId"
              clearable
              placeholder="请输入开发者账号"
              maxlength="36"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="对接应用授权KEY">
            <el-input v-model="formData.appkey" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="对接应用授权加密字符">
            <el-input v-model="formData.appSecret" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="授权到期时间" prop="expiresIn">
            <el-date-picker
              v-model="formData.expiresIn"
              placeholder="请选择时间"
              value-format="timestamp"
              type="date"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="三方服务器地址" prop="tpAppHost">
            <el-input
              v-model="formData.tpAppHost"
              placeholder="请输入三方服务器地址"
              clearable
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="三方应用授权KEY">
            <el-input
              v-model="formData.tpAppkey"
              placeholder="请输入三方应用授权KEY"
              clearable
              maxlength="36"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="三方应用授权加密字符">
            <el-input
              v-model="formData.tpAppSecret"
              placeholder="请输入三方应用授权加密字符"
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input
              v-model="formData.remark"
              placeholder="请输入备注"
              type="textarea"
              maxlength="500"
              rows="3"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: { type: Boolean, default: false },
    clientCode: { type: String, default: '' },
    appKey: { type: String, default: '' },
  },
  mounted() {
    this.getData()
  },
  data() {
    return {
      formData: {},
      rules: {
        accountCode: [
          {
            required: true,
            message: '请输入机构账号编码',
            trigger: 'blur',
          },
        ],
        appId: [
          {
            required: true,
            message: '开发者账号不能为空',
            trigger: 'blur',
          },
        ],
        expiresIn: [
          {
            required: true,
            message: '请选择授权到期日期',
            trigger: 'change',
          },
        ],
        tpAppHost: [
          {
            required: true,
            message: '请输入格式正确的地址',
            trigger: 'blur',
            pattern: /(\w+):\/\/([^/:]+)(:\d*)?/,
          },
        ],
      },
    }
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getData() {
      if (!this.clientCode) return
      const res = await this.$api
        .sysOpenapiClientDetailApi({ clientCode: this.clientCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
      this.$emit('update:appKey', this.formData.appkey)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      const res = await this.$api
        .sysOpenapiClientSaveApi(this.formData)
        .catch(() => null)
      loading.close()
      if (!res) return
      const { status } = res
      if (status === 200) {
        this.$message({
          showClose: true,
          message: res.msg,
          type: 'success',
        })
        if (this.clientCode) {
          this.getData()
        } else {
          this.closeCurPage()
        }
      }
    },
    async closeCurPage() {
      await this.close({ tagName: this.$route.fullPath, showConfirm: false })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
